module.exports = __webpack_public_path__ + "static/team3-fb01194710d300d82927b0a63044af4e.jpg";